import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

// Routes where the global floating back button must NOT appear.
// Includes:
// - Home (root destination of bottom nav)
// - Auth flows (have their own layout/navigation)
// - Public note share pages (own layout)
// - Pages that already render their own back button inside the header
//   (avoid double back buttons / overlap with sticky headers).
const HIDDEN_ROUTES = [
  '/',
  '/home',
  '/app',
  '/login',
  '/signup',
  '/complete-profile',
  '/verify-email',
  '/forgot-password',
  '/reset-password',
  '/colecoes',
  '/notificacoes',
  '/termos',
  '/privacidade',
  '/profile',
  '/generate',
  '/annotations',
  '/livros',
  '/assinatura/sucesso',
  '/admin',
  '/biblioteca',
  '/busca',
  '/em-alta',
  '/series',
  '/jornada',
  '/sobre',
  '/artigos',
  '/como-funciona',
  '/presente',
  '/presente/sucesso',
  '/instalar',
];

const HIDDEN_PREFIXES = [
  '/nota/',         // public note share pages
  '/colecoes/',     // collection detail (has own header back)
  '/note/',         // note reader + devotional (have own headers)
  '/series/',       // series detail (has own header back)
  '/igrejas/',      // church detail (has own header back)
  '/artigo/',       // article detail pages
];

const GlobalBackButton = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isHidden =
    HIDDEN_ROUTES.includes(location.pathname) ||
    HIDDEN_PREFIXES.some((p) => location.pathname.startsWith(p));

  if (isHidden) return null;

  const handleBack = () => {
    // Prefer history back; fall back to home if no history
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button
      type="button"
      onClick={handleBack}
      aria-label="Voltar"
      style={{ top: 'calc(env(safe-area-inset-top, 0px) + 0.75rem)', left: 'calc(env(safe-area-inset-left, 0px) + 0.75rem)' }}
      className="fixed z-[60] inline-flex items-center justify-center h-10 w-10 rounded-full bg-card/95 backdrop-blur border border-border shadow-md text-foreground hover:bg-card active:scale-95 transition"
    >
      <ArrowLeft className="h-5 w-5" />
    </button>
  );
};

export default GlobalBackButton;
